import React from 'react';

var SvgNatureIcon = function SvgNatureIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 3a1 1 0 0 0-1 1v4.25a6.75 6.75 0 0 0 6.75 6.75v1.25a.75.75 0 0 0 1.5 0v-1.293a6.501 6.501 0 0 0 5.75-6.457v-1.52a.98.98 0 0 0-.98-.98c-1.99 0-3.762.926-4.91 2.371a6.752 6.752 0 0 0-6.61-5.371h-.5Zm8.035 10.26a5.002 5.002 0 0 0 3.465-4.76v-.972a4.772 4.772 0 0 0-4.227 4.275l1.387-1.766a.75.75 0 1 1 1.18.926l-1.805 2.297Zm-5.905-4.338 3.104 4.553a5.25 5.25 0 0 1-4.734-5.225v-3.75c2.9 0 5.25 2.35 5.25 5.25v1.819l-2.38-3.492a.75.75 0 1 0-1.24.845Z"
  }));
};
SvgNatureIcon.displayName = "NatureIcon";

export { SvgNatureIcon as S };
